import Header from "./components/header/Header.js";
import "./App.css";
import Slider from "./components/slider/Slider.js";

function App() {
  return (
    <div className="container">
      <Header />
      <Slider />
    </div>
  );
}

export default App;
